export default [
  // ================ receipt ================
  {
    name: "receipt_index",
    path: "/employee/receipt",
    component: () => import("../pages/employee/receipt/index.vue"),
  },
  // {
  //   name: "receipt_show",
  //   path: "/employee/receipt/:receipt_number",
  //   component: () => import("../pages/employee/receipt/index.vue"),
  //   props: true, 
  // },
  // {
  //   name: "receipt_create",
  //   path: "/employee/receipt/create",
  //   component: () => import("../pages/employee/receipt/manage.vue"),
  // },
  // {
  //   name: "receipt_update",
  //   path: "/administrator/receipt/update/:id",
  //   component: () => import("../pages/employee/receipt/manage.vue"),
  // },
  // {
  //   name: "receipt_log",
  //   path: "/administrator/receipt/log-activity",
  //   component: () => import("../pages/employee/receipt/log.vue"),
  // },

];
